<template>
    <div class="min-h-full h-full pt-16 pb-12 flex flex-col bg-gray-900">
        <main class="grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
            <div class="shrink-0 flex justify-center">
                <a href="/">
                    <img class="h-12 w-auto" src="/svg/logo.svg" alt="" style="margin-left: 95px" />
                </a>
            </div>
            <div class="py-16">
                <AppCard>
                    <slot />
                </AppCard>
            </div>
        </main>
    </div>
    <div id="modals"></div>
    <div id="slide-overs"></div>
</template>

<script>
import AppCard from '@/Shared/AppCard.vue';

export default {
    name: 'SmileyPollLayout',
    components: {
        AppCard,
    },
    mounted() {
        document.querySelector('html').style.height = '100%';
        document.querySelector('body').style.height = '100%';
        document.querySelector('#app').style.height = '100%';
    },
};
</script>
